/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import SendEmailHeader from 'infrastructure/email/sendEmail/shared/SendEmailHeader';
import { useFormContext } from 'framework/form';

const UpdateSendEmailPageLayout = ({ children }: { children: React.ReactElement }) => {
  const { data } = useFormContext();
  const { taskName } = data || {};

  return (
    <UpdatePageLayout title="Edit: Email" breadcrumbs={<SendEmailHeader taskName={taskName} />}>
      {children}
    </UpdatePageLayout>
  );
};

export default UpdateSendEmailPageLayout;
